'use client';

import { FC } from 'react';

import { useSegment } from '@telialt/utils/src/segment';

import { apiGetUniqueOfferSSDocument } from './api';
import { TriggerDownloadButton } from './components/TriggerDownloadButton';
import { TriggerDownloadLink } from './components/TriggerDownloadLink';
import { ContractSummaryButtonProps, UniqueOfferWithMsisdnDocumentRequestParams } from './model';
import { useDownloadFileOrGiveDownloadLink } from './useDownloadFileOrGiveDownloadLink';

type Props = { params: UniqueOfferWithMsisdnDocumentRequestParams } & ContractSummaryButtonProps;

export const DownloadUniqueOfferWithMsisdnContractSummaryButton: FC<Props> = ({ className, params, isNegative }) => {
    const segment = useSegment();
    const { fileDownloadLink, isPending, download } = useDownloadFileOrGiveDownloadLink(
        async () => (await apiGetUniqueOfferSSDocument(segment, params)).data.fileUrl,
        ['unique-offer-with-msisdn', segment, params],
    );

    if (fileDownloadLink) {
        return <TriggerDownloadLink href={fileDownloadLink} className={className} isNegative={isNegative} />;
    }

    return (
        <TriggerDownloadButton onClick={download} isLoading={isPending} className={className} isNegative={isNegative} />
    );
};
